import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=6791dcf9&scoped=true"
import script from "./Manager.vue?vue&type=script&lang=js"
export * from "./Manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6791dcf9",
  null
  
)

export default component.exports